const maintainFundRouter = [
	{
		path: '/maintainFund',
		name: 'MaintainFund',
		component: () => import('@/views/maintainFund')
	},
	// 选择小区
	{
		path: '/maintainFund/regions',
		name: 'Regions',
		component: () => import('@/views/maintainFund/Regions')
	},
	// 绑定房屋
	{
		path: '/maintainFund/bindingHouse',
		name: 'BindingHouse',
		component: () => import('@/views/maintainFund/BindingHouse')
	},
	//在线交存
	{
		path: '/maintainFund/houseDeposit',
		name: 'HouseDeposit',
		component: () => import('@/views/maintainFund/HouseDeposit')
	},
	//票据获取
	{
		path: '/maintainFund/billObtain/main',
		name: 'BillMain',
		component: () => import('@/views/maintainFund/billObtain/main')
	},

	//在线交存详情信息
	{
		path: '/maintainFund/depositInfo',
		name: 'DepositInfo',
		component: () => import('@/views/maintainFund/DepositInfo')
	},
	// 我的房屋
	{
		path: '/maintainFund/houseList',
		name: 'HouseList',
		component: () => import('@/views/maintainFund/HouseList')
	},
	// 核验购房人（待交）
	{
		path: '/maintainFund/ownerConfirm',
		name: 'OwnerConfirm',
		component: () => import('@/views/maintainFund/OwnerConfirm')
	},
	//我的房屋详细信息
	{
		path: '/maintainFund/houseListInfo',
		name: 'HouseListInfo',
		component: () => import('@/views/maintainFund/HouseListInfo')
	},
	//房屋交易详情
	{
		path: '/maintainFund/houseTradeList',
		name: 'HouseTradeList',
		component: () => import('@/views/maintainFund/HouseTradeList')
	},
	// 在线表决
	{
		path: '/maintainFund/voteList',
		name: 'VoteList',
		component: () => import('@/views/maintainFund/VoteList')
	},
	// 在线表决详细信息
	{
		path: '/maintainFund/voteListInfo',
		name: 'VoteListInfo',
		component: () => import('@/views/maintainFund/VoteListInfo')
	},
	//
	{
		path: '/maintainFund/ownerChange',
		name: 'OwnerChange',
		component: () => import('@/views/maintainFund/OwnerChange')
	},
	{
		path: '/maintainFund/OwnerChangeList',
		name: 'OwnerChangeList',
		component: () => import('@/views/maintainFund/OwnerChangeList')
	},
	{
		path: '/maintainFund/businessProcessAppoint',
		name: 'BusinessProcessAppoint',
		component: () => import('@/views/maintainFund/BusinessProcessAppoint')
	},
	{
		path: '/maintainFund/myAppointBusiness',
		name: 'MyAppointBusiness',
		component: () => import('@/views/maintainFund/MyAppointBusiness')
	},{
		path: '/maintainFund/businessProcessDetail',
		name: 'BusinessProcessDetail',
		component: () => import('@/views/maintainFund/BusinessProcessDetail')
	},


]
export default maintainFundRouter
